
import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import("../pages/home/page"));
const AgencesPage = lazy(() => import("../pages/agences/page"));
const EntreprisesPage = lazy(() => import("../pages/entreprises/page"));
const FormateursPage = lazy(() => import("../pages/formateurs/page"));
const FormationsPage = lazy(() => import("../pages/formations/page"));
const AProposPage = lazy(() => import("../pages/a-propos/page"));
const BlogPage = lazy(() => import("../pages/blog/page"));
const ContactPage = lazy(() => import("../pages/contact/page"));
const NotFoundPage = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/agences",
    element: <AgencesPage />,
  },
  {
    path: "/entreprises",
    element: <EntreprisesPage />,
  },
  {
    path: "/formateurs",
    element: <FormateursPage />,
  },
  {
    path: "/formations",
    element: <FormationsPage />,
  },
  {
    path: "/a-propos",
    element: <AProposPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export default routes;
